import { createContext, useContext, useEffect, useState } from 'react';

// Fixed FX rates (USD base). Update here if needed.
export const CURRENCIES = {
  USD: { code: 'USD', symbol: '$',  rate: 1.0,  label: 'US Dollar' },
  AUD: { code: 'AUD', symbol: 'A$', rate: 1.55, label: 'Australian Dollar' },
  EUR: { code: 'EUR', symbol: '€',  rate: 0.92, label: 'Euro' },
};

const STORAGE_KEY = 'lumiere_currency_v1';
const CurrencyContext = createContext(null);

export const CurrencyProvider = ({ children }) => {
  const [code, setCode] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || 'USD'; } catch (e) { return 'USD'; }
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, code); } catch (e) { /* ignore */ }
  }, [code]);

  const cur = CURRENCIES[code] || CURRENCIES.USD;
  const convert = (usd) => +(usd * cur.rate).toFixed(2);
  const format = (usd) => `${cur.symbol}${convert(usd).toFixed(2)}`;

  return (
    <CurrencyContext.Provider value={{ code, setCode, currency: cur, convert, format }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error('useCurrency outside provider');
  return ctx;
};
